import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { MobileNav } from './MobileNav'
import { useUIStore } from '@/stores/uiStore'

export function AppLayout() {
  const { sidebarOpen, setSidebarOpen } = useUIStore()
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className="flex min-h-screen">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      <div className="flex-1 lg:ml-64">
        <Header onMenuClick={() => setMobileNavOpen(true)} />
        <main className="container mx-auto p-6 max-w-7xl">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
